
<div class="editable-control-container" (mouseenter)="toggleEditButton(true)" (mouseleave)="toggleEditButton(false)">
    <div class="editable-control-wrapper">
        <div class="editable-control">
            <!-- Display Mode -->
             @if(!isEditMode){
                <span class="display-mode cursor-default" [style.min-height.px]="minHeight()">
                    {{ displayValue || '&nbsp;' }}
                </span>
            }
            <!-- Edit Mode -->
            @else{
                <div class="edit-mode-wrapper">
                    <ng-content select="[editInput]"></ng-content>
                </div>
            }
        </div>
    </div>
    
    <!-- Edit Button (shown when not in edit mode) -->
     @if(allowIndividualEditMode() && !isEditMode && showEditButton){
        <button 
            type="button"
            class="edit-button"
            (click)="enterEditMode()"
            title="Edit">
            ✎
        </button>
    }
</div>